import { render, staticRenderFns } from "./BoxCard.vue?vue&type=template&id=7fb6eb57&scoped=true&"
import script from "./BoxCard.vue?vue&type=script&lang=js&"
export * from "./BoxCard.vue?vue&type=script&lang=js&"
import style0 from "./BoxCard.vue?vue&type=style&index=0&id=7fb6eb57&lang=scss&"
import style1 from "./BoxCard.vue?vue&type=style&index=1&id=7fb6eb57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.1_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_vue-template_rpjj46s3fsyrbdrx36iiyr4l4y/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb6eb57",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\21.zhangzhiyi\\web-system\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fb6eb57')) {
      api.createRecord('7fb6eb57', component.options)
    } else {
      api.reload('7fb6eb57', component.options)
    }
    module.hot.accept("./BoxCard.vue?vue&type=template&id=7fb6eb57&scoped=true&", function () {
      api.rerender('7fb6eb57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/BoxCard.vue"
export default component.exports